import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { BaseNavLink, FooterLink } from '@hdms/shared/page-frame/types';
import { Accordion, AccordionComponent, AccordionService, IconsName, SizeOption } from '@hdms/shared/ui-core';
import { BreakpointService, PlatformService } from '@hdms/shared/util-core';

@Component({
  selector: 'shrd-pf-ui-links-column-accordion',
  templateUrl: './links-column-accordion.component.html',
  styleUrls: ['./links-column-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LinksColumnAccordionComponent implements Accordion, OnInit, OnDestroy {
  readonly sizeOption = SizeOption;
  readonly iconName = IconsName;

  @ViewChild(AccordionComponent) accordion: AccordionComponent;

  @Input() sectionTitle: string;
  @Input() links: BaseNavLink[] | FooterLink[];
  @Input() isLast = false;

  isMobile = true;
  isServer = this.platform.isServer;

  private readonly ngOnDestroy$ = new Subject<void>();

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly platform: PlatformService,
    private readonly accordionService: AccordionService,
    private readonly breakpointService: BreakpointService
  ) {}

  ngOnInit(): void {
    this.accordionService.register(this);
    this.subscribeToBreakpointChange();
  }

  ngOnDestroy(): void {
    this.accordionService.unregister(this);
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  triggerToggle(): void {
    this.accordionService.toggle(this);
  }

  trackByIndex(index: number): number {
    return index;
  }

  public toggleOpen(): void {
    this.accordion.toggleOpen();
    this.cdr.detectChanges();
  }

  public close(): void {
    this.accordion.close();
    this.cdr.detectChanges();
  }

  private subscribeToBreakpointChange(): void {
    this.platform.isBrowser &&
      this.breakpointService.isMobileView$.pipe(takeUntil(this.ngOnDestroy$)).subscribe(isMobile => {
        this.isMobile = isMobile;
        this.cdr.detectChanges();
      });
  }
}
